import { useTranslation } from 'react-i18next'

import Text from '../../../Text'

import * as styles from './EpostStatusTimelineContentContainer.module.css'

function EpostStatusTimelineContentContainer({
  children,
  contentClassName = styles.content,
  titleKey,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.EpostStatusTimelineContentContainer}>
      <Text className={styles.title}>{t(titleKey)}</Text>

      <div className={contentClassName}>{children}</div>
    </div>
  )
}

export default EpostStatusTimelineContentContainer
